import { InventoryConfig } from '../../types/aptConfig'
import { AreaInspection, InventoryInspection } from '../../types/inspection'
import {
    InspectionActionTypes,
    SET_AREA_INSPECTION,
    SET_INVENTORY_CONFIG,
    SET_INVENTORY_INSPECTION,
} from './types'

export interface InspectionState {
    inventoryInspection?: InventoryInspection
    inventoryConfig?: InventoryConfig
    areaInspection?: AreaInspection
}

const initialState: InspectionState = {}

export const inspectionReducer = (
    state = initialState,
    action: InspectionActionTypes,
): InspectionState => {
    switch (action.type) {
        case SET_INVENTORY_INSPECTION:
            return {
                ...state,
                inventoryInspection: action.inventoryInspection,
            }
        case SET_INVENTORY_CONFIG:
            return {
                ...state,
                inventoryConfig: action.inventoryConfig,
            }
        case SET_AREA_INSPECTION:
            return {
                ...state,
                areaInspection: action.areaInspection,
            }
        default:
            return state
    }
}
